import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import CountUp from "react-countup";
import {
  FaCalendarCheck,
  FaHardHat,
  FaUsers,
  FaUserShield,
} from "react-icons/fa";
import { HiArrowRight, HiChevronDown } from "react-icons/hi";
import { MdCheckCircle, MdDesignServices, MdEngineering } from "react-icons/md";
import { Link } from "react-router-dom";
import serviceImage1 from "../assets/constrserv.jpg";
import serviceImage4 from "../assets/fireserv.webp";
import serviceImage5 from "../assets/ict2.avif";
import hero2, { default as hero1 } from "../assets/jc5.jpg";
import exampleImage from "../assets/homeabt.jpeg";
import homewelcome from "../assets/homew.webp";
import { default as hero } from "../assets/jc4.jpg";
import serviceImage3 from "../assets/pest1.jpg";
import ClientsPartners from "../components/ClientsPartners";
import img3 from "../assets/jc8.jpg";
import img2 from "../assets/jf1.png";
import img1 from "../assets/concretemixer.jpg";

const services = [
  {
    image: serviceImage1,
    icon: <MdEngineering className="w-8 h-8 text-black" />,
    title: "Construction & Civil Works",
    description: "We deliver innovative designs and solid construction.",
    path: "/services/build-construction",
  },
  {
    image: serviceImage4,
    icon: <MdDesignServices className="w-8 h-8 text-black" />,
    title: "Fire Safety Solutions",
    description: "Professional installation and maintenance of fire safety systems.",
    path: "/services/fire-services",
  },
  {
    image: serviceImage5,
    icon: <MdDesignServices className="w-8 h-8 text-black" />,
    title: "ICT & Security Solutions",
    description: "Professional ICT, telecommunication, and security solutions to keep your systems efficient and safe.",
    path: "/services/ict-and-security",
  },
  {
    image: serviceImage3,
    icon: <MdCheckCircle className="w-8 h-8 text-black" />,
    title: "Pest & Fumigation",
    description: "Effective pest control and fumigation services to ensure a clean, safe, and healthy environment.",
    path: "/services/fumigation-services",
  },
];

const faqs = [
  {
    id: 1,
    question: "What makes your construction services unique?",
    answer:
      "We combine innovative design, strict safety standards, and skilled engineering to deliver projects that stand the test of time.",
  },
  {
    id: 2,
    question: "Do you offer materials for all project sizes?",
    answer:
      "Yes. We supply a wide range of certified building materials suitable for everything from residential builds to large-scale commercial projects.",
  },
  {
    id: 3,
    question: "How do you ensure fire safety compliance?",
    answer:
      "Our team installs and maintains fire equipment that meets international standards, helping protect lives, assets, and businesses.",
  },
];

const stats = [
  {
    value: 120,
    label: "Projects Completed",
    icon: <FaHardHat />,
  },
  {
    value: 80,
    label: "Happy Clients",
    icon: <FaUsers />,
  },
  {
    value: 10,
    label: "Years of Experience",
    icon: <FaCalendarCheck />,
  },
  {
    value: 25,
    label: "Certified Experts",
    icon: <FaUserShield />,
  },
];



function Home() {
  const slides = [hero, hero1, hero2];
  const [currentSlide, setCurrentSlide] = useState(0);
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 8000); // 8 seconds per slide
    return () => clearInterval(interval);
  }, []);


  const toggleFAQ = (id) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <div className="">

      {/* hero section */}
      <section className="relative w-full h-[80vh] overflow-hidden mb-10">
        {/* Slides */}
        {slides.map((image, index) => {
          const isCurrent = index === currentSlide;
          return (
            <motion.div
              key={index}
              className="absolute inset-0 bg-cover bg-center"
              style={{ backgroundImage: `url(${image})`, zIndex: isCurrent ? 20 : 10 }}
              initial={{ y: "-100%" }}
              animate={{ y: isCurrent ? 0 : "100%" }}
              transition={{ duration: 2, ease: "easeInOut" }}
            >
              <div className="absolute inset-0 bg-black bg-opacity-50"></div>
            </motion.div>
          );
        })}

        {/* Text overlay */}
        <motion.div
          key={currentSlide}
          className="relative z-30 flex flex-col items-start justify-center h-full px-6  max-w-6xl mx-auto text-white"
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          {/* First paragraph */}
          <p className="bg-black bg-opacity-20 px-3 py-1 rounded text-sm md:text-base mb-3 uppercase tracking-wide text-primary">
            One Partner. Endless Possibilities.
          </p>

          {/* Heading */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
            Complete Solutions for <br /> Smarter, Safer Projects
          </h1>

          {/* Description */}
          <p className="text-base md:text-lg lg:text-xl mb-8 max-w-2xl">
            Integrated solutions in construction, safety, ICT, and pest control —
            built for reliability, efficiency, and long-term performance.
          </p>

          {/* Button with arrow */}
          <Link
            to="/contact"
            className="inline-flex items-center gap-3 px-6 py-3 bg-primary hover:bg-primary/60 text-black font-medium rounded-md transition-all"
          >
            Contact Us
            <span className="bg-white p-2 rounded-full flex items-center justify-center">
              <HiArrowRight className="w-5 h-5 text-black" />
            </span>
          </Link>
        </motion.div>
      </section>

      {/* about section */}
      <section className="w-full py-16 bg-gray-50">
        <div className="mx-auto max-w-6xl flex flex-col md:flex-row items-stretch gap-10 px-6">

          {/* Image */}
          <motion.img
            src={exampleImage}
            alt="About Jighuluke"
            loading="lazy"
            className="w-full md:w-1/2 h-96 md:h-auto object-cover rounded-lg shadow-lg"
            initial={{ x: -100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
          />

          {/* Content */}
          <motion.div
            className="flex flex-col gap-6 md:w-1/2 h-full"
            initial={{ x: 100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
          >
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800">
              Reliable Solutions for Building, Safety & Technology
            </h2>
            <p className="text-gray-600 text-base md:text-lg">
              We are partners in your success. Our team delivers reliable
              construction services, premium materials, fire safety solutions, trusted machinery
              rentals, ICT & security systems, and professional pest control to keep your projects moving forward with confidence.
            </p>

            {/* Icons with texts */}
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-10">
              <div className="flex items-center gap-2">
                <span className="bg-primary p-2 rounded-none text-black">
                  <MdEngineering className="w-6 h-6" />
                </span>
                <span className="text-gray-700 font-medium">Expert Engineering</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="bg-primary p-2 rounded-none text-black">
                  <MdCheckCircle className="w-6 h-6" />
                </span>
                <span className="text-gray-700 font-medium">Quality Assurance</span>
              </div>
            </div>

            {/* Project progress */}
            <div className="flex flex-col gap-2">
              <div className="flex justify-between text-gray-600 font-medium">
                <p>Sfety commitment</p>
                <p>100+</p>
              </div>
              <div className="w-full bg-gray-300 h-2 rounded-full">
                <div className="bg-primary h-2 rounded-full w-4/5 transition-all duration-1000"></div>
              </div>
            </div>

            {/* Button with arrow */}
            <Link
              to="/about"
              className="inline-flex items-center gap-3 px-6 py-3 bg-secondary text-primary font-medium rounded-md transition-all w-max"
            >
              About Us
              <span className="bg-white p-2 rounded-full flex items-center justify-center">
                <HiArrowRight className="w-5 h-5 text-black" />
              </span>
            </Link>
          </motion.div>
        </div>
      </section>

      {/* service section */}
      <section className="w-full py-16 pb-28 mb-10">
        <div className="flex flex-col relative">

          {/* Header Section */}
          <motion.div
            className="bg-black w-full text-white pt-16 pb-48 min-h-[350px]"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
          >
            <div className="mx-auto max-w-6xl w-full flex flex-col md:flex-row justify-between items-start md:items-center gap-6 md:gap-10 pb-14 px-6">
              {/* Left Side */}
              <div className="flex flex-col gap-4">
                <p className="uppercase text-yellow-500 font-medium tracking-wider">
                  Committed to Excellence
                </p>
                <h2 className="text-3xl md:text-4xl font-bold">
                  Our Reliable Services
                </h2>
              </div>

              {/* Right Side */}
              <p className="text-gray-300 max-w-md">
                From design and construction to reliable materials, fire protection, ICT & security and pest control —
                we deliver complete solutions that ensure your projects are built to last.

              </p>
            </div>
          </motion.div>


          {/* Services Cards Section */}
          <div className="grid mx-auto max-w-6xl grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 -mt-48 px-6">
            {services.map((service, index) => (
              <motion.div
                key={index}
                className="group relative bg-white hover:bg-secondary hover:border hover:border-primary rounded-sm shadow-lg overflow-hidden flex flex-col h-80 md:h-96"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
              >
                {/* Image / Icon Section */}
                <div className="relative h-1/2">
                  <img
                    src={service.image}
                    alt={service.title}
                    loading="lazy"
                    className="w-full px-3 pt-3 h-full object-cover"
                  />
                  <div className="absolute -bottom-7 left-6 bg-primary p-4 rounded-none shadow-lg">
                    {service.icon}
                  </div>
                </div>

                {/* Text Content */}
                <div className="flex flex-col gap-2 p-4 h-1/2 justify-between pt-10">
                  <div>
                    <p className="text-xl font-semibold text-gray-800 group-hover:text-gray-100">
                      {service.title}
                    </p>
                    <p className="text-gray-600 text-sm mt-1 group-hover:text-gray-100">
                      {service.description}
                    </p>
                  </div>
                  <Link
                    to={service.path}
                    className="inline-flex items-center gap-2 text-black group-hover:text-gray-100 font-medium mt-2 group-hover:underline"
                  >
                    Read More
                    <span className="p-2 rounded-full text-black group-hover:text-gray-100 flex items-center justify-center">
                      <HiArrowRight className="w-4 h-4" />
                    </span>
                  </Link>
                </div>
              </motion.div>

            ))}
          </div>
        </div>
      </section>

      {/* stats section */}
      <section
        className="relative bg-cover bg-center bg-no-repeat py-20"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1503387762-592deb58ef4e')",
        }}
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-gray-900/80 to-black/80"></div>

        <div className="relative max-w-7xl mx-auto px-6">
          {/* Heading */}
          <div className="text-center mb-14">
            <h2 className="text-3xl md:text-4xl font-bold text-white">
              Our Impact in Numbers
            </h2>
            <p className="text-gray-300 mt-3 max-w-2xl mx-auto">
              Proven excellence in construction, fire safety, ICT & security, and
              pest control services
            </p>
          </div>

          {/* Stats Grid */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.15 }}
                viewport={{ once: true }}
                className="bg-white/10 backdrop-blur-md rounded-2xl p-8 text-center shadow-xl border border-white/10"
              >
                {/* Icon */}
                <div className="text-4xl text-yellow-400 mb-4 flex justify-center">
                  {stat.icon}
                </div>

                {/* Number */}
                <h3 className="text-4xl font-extrabold text-white">
                  <CountUp
                    start={0}
                    end={stat.value}
                    duration={2.5}
                    enableScrollSpy
                    scrollSpyOnce
                  />
                  
                  +
                </h3>

                {/* Label */}
                <p className="text-gray-300 mt-2 text-sm uppercase tracking-wider">
                  {stat.label}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <ClientsPartners />

      {/* faq */}
      <section className="w-full bg-secondary py-10 mb-10">
        <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Side */}
          <div className="flex flex-col gap-6 text-white">
            <p className="uppercase text-primary font-semibold tracking-wide">
              Your trusted partner
            </p>
            <h2 className="text-3xl md:text-4xl font-bold leading-snug">
              Experience, Quality, and Safety <br /> You Can Rely On
            </h2>

            {/* Accordion */}
            <div className="flex flex-col gap-4 mt-4">
              {faqs.map((faq) => (
                <div
                  key={faq.id}
                  className="bg-primary/25 rounded-sm shadow-md overflow-hidden"
                >
                  <button
                    className="w-full flex justify-between items-center text-left px-5 py-4 text-lg font-medium text-white"
                    onClick={() => toggleFAQ(faq.id)}
                  >
                    <span className="flex items-center gap-2">
                      <span className="text-primary font-bold">
                        0{faq.id}.
                      </span>
                      {faq.question}
                    </span>
                    <HiChevronDown
                      className={`w-5 h-5 transform transition-transform duration-300 ${openId === faq.id ? "rotate-180 text-primary" : ""
                        }`}
                    />
                  </button>
                  {openId === faq.id && (
                    <div className="px-5 pb-4 text-gray-300 text-sm">
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Right Side (Images) */}
          <div className="grid grid-cols-2 gap-6">
            <img
              src={img1}
              alt="Workers"
              loading="lazy"
              className="w-full h-56 object-cover rounded-md"
            />
            <img
              src={img2}
              alt="Engineer"
              loading="lazy"
              className="w-full h-72 object-cover rounded-md"
            />
            <img
              src={img3}
              alt="Construction"
              loading="lazy"
              className="w-full h-56 object-cover rounded-md col-span-2"
            />
          </div>
        </div>
      </section>

      {/* welcome */}
      <section className="mx-auto max-w-6xl px-6 py-10 mb-10">
        <div className="relative w-full h-[400px] md:h-[500px] rounded-sm overflow-hidden flex flex-col md:flex-row">

          {/* Left - Background Image */}
          <div className="relative w-full md:w-1/2 h-1/2 md:h-full">
            <img
              src={homewelcome}
              alt="Construction site"
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black bg-opacity-40"></div>
          </div>

          {/* Right - Text Content */}
          <motion.div
            className="w-full md:w-1/2 bg-secondary flex flex-col justify-center items-start text-white p-6 md:p-12 relative "
            initial={{ opacity: 0, x: 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <p className="uppercase text-primary font-semibold tracking-wide">
              Your Vision, Our Expertise
            </p>
            <h2 className="text-2xl md:text-4xl font-bold mt-2">
              We supply and build with you.
            </h2>
            <p className="mt-4 max-w-lg text-gray-200 text-sm md:text-base">
              From design to construction, we deliver professional solutions
              with quality and reliability at the core.
            </p>
            <Link
              to="/contact"
              className="mt-6 inline-flex items-center gap-2 px-6 py-3 bg-primary hover:bg-primary/60 text-black font-medium rounded-md transition-all"
            >
              Contact Us
              <span className="bg-white p-2 rounded-full flex items-center justify-center">
                <HiArrowRight className="w-5 h-5 text-black" />
              </span>
            </Link>
          </motion.div>
        </div>
      </section>

    </div>

  );
}

export default Home;
